import dayjs from 'dayjs';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import User from 'public/user.svg';
import { Review } from 'types/Review';
import { Card, Content, ContentHeader, Date, P, UserImage, UserName } from './ReviewCard.styled';
interface Props {
  data: Review;
}
export default function ReviewCard({ data }: Props) {
  const { t } = useTranslation('Product');

  return (
    <Card>
      <UserImage>
        {data.user.avatar ? (
          <Image src={data.user.avatar} width={50} height={50} alt="user" />
        ) : (
          <Image src={User} width={18} height={18} alt="user placeholder" />
        )}
      </UserImage>
      <Content>
        <ContentHeader>
          <UserName>{data.user.full_name || t('guest')}</UserName>
          <Date dir="ltr">{dayjs(data.created_date).format('DD MMM YYYY')}</Date>
        </ContentHeader>
        <P>{data.comment}</P>
      </Content>
    </Card>
  );
}
